import { Config, httpPost } from "../../services/api";

export const sdkApplePaySession = async ({
  validationUrl,
  secret,
  parentOrigin,
  methodId,
}: {
  secret: string | null;
  methodId: string | null;
  validationUrl: string;
  parentOrigin: string;
}) => {
  return httpPost(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/providers/applepay/session/`,
    {
      ...(secret && { secret }),
      ...(methodId && { method_id: methodId }),
      validation_url: validationUrl,
      parent_origin: parentOrigin,
    },
    true
  );
};
